function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

/**
 *  @class
 *  @function FacetsToggle
 */
class FacetsToggle {

  constructor() {
    this.container = document.getElementById('Facet-Drawer');
    let button = document.getElementById('Facets-Toggle');

    // Add functionality to buttons
    if (button) {
      button.addEventListener('click', (e) => {
        e.preventDefault();
        document.getElementsByTagName("body")[0].classList.toggle('open-cc');
        this.container.classList.toggle('active');
        this.container.querySelector('side-panel-close')?.focus();
      });
    }

  }
}


class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    this.querySelectorAll('.decorative-stock-filter').forEach((filter) => {
      filter.addEventListener('click', (event) => {
        /** Ensures the decorative toggles on mobile and desktop are always checked or unchecked together */
        document.querySelectorAll('.decorative-stock-filter').forEach((toggle) => {
          if (toggle.checked !== event.target.checked) toggle.checked = event.target.checked
        })

        /**@description Updates the availability and in stocks filters whenever the decorative 'Show in Stock Only' toggles are clicked - Both filters are needed to stop products with 0 inventory from showing when the 'Show in stock only' toggle is enabled (They otherwise these products show due to ‘Continue selling when out of stock’ needing to be on for each product for layaway) */
        const availabilityInput = document.querySelector("input[name='filter.v.availability']");
        const inStockCheckInput = document.querySelector('input[name="filter.p.m.custom.in_stock"]');
        if (availabilityInput && inStockCheckInput) {
          availabilityInput.click()
          inStockCheckInput.click()

          //Debounced triggering the form input because otherwise it happens before debouncedOnSubmit, and '.decorative-stock-filter' doesn't work on mobile
          this.debouncedInputEvent(availabilityInput);
        } else {
          console.error("Couldn't find either/both the availability or in stock filter inputs");
        }
      })
    })


    this.debouncedInputEvent = debounce((availabilityInput) => {
      availabilityInput.closest('form').dispatchEvent(new Event('input', { bubbles: true }));
    }, 501)

    this.debouncedOnSubmit = debounce((event) => {
      /**Don't activate the usual filter functionality if the input is one of the decorative checkboxes as they already activate the appropriate filters via the '.decorative-stock-filter' event listener */
      if (!event.target.classList.contains("decorative-stock-filter")) {
        this.onSubmitHandler(event);
      }
    }, 500);

    this.querySelector('form').addEventListener('input', this.debouncedOnSubmit.bind(this));
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    };
    window.addEventListener('popstate', onHistoryChange);

    const onResize = debounce((event) => {
      let root = document.documentElement,
        header = document.querySelector('.header'),
        height = header.clientHeight;

      if (window.innerWidth <= 768) {
        root.style.setProperty('--header-height-mobile', height + "px");
      }
    }, 200);
    window.addEventListener('resize', onResize);
    window.dispatchEvent(new Event('resize'));
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable);
    });
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();
    const container = document.getElementsByClassName('thb-filter-count');
    document.getElementById('ProductGridContainer').querySelector('.collection').classList.add('loading');
    //Disable the mobile and desktop stock filters while other filters are loading - Else the stock checkboxes can get out of sync with each other and the filter itself
    document.querySelectorAll('.decorative-stock-filter').forEach((stockToggle) => stockToggle.disabled = true);

    for (var item of container) {
      item.classList.add('loading');
    }

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = element => element.url === url;

      if (FacetFiltersForm.filterData.some(filterDataUrl)) {
        FacetFiltersForm.renderSectionFromCache(filterDataUrl, event);
      } else {
        FacetFiltersForm.renderSectionFromFetch(url, event);
      }
    });
    if (typeof FacetRemove !== 'undefined') {
      // customElements.define('facet-remove', FacetRemove);
    }
    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
  }

  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then(response => response.text())
      .then((responseText) => {
        const html = responseText;
        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, {
          html,
          url
        }];
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
        FacetFiltersForm.renderProductCount(html);
      });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    FacetFiltersForm.renderProductCount(html);
  }

  static renderProductGridContainer(html) {
    document.getElementById('ProductGridContainer').innerHTML = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductGridContainer').innerHTML;

  }

  static renderProductCount(html) {
    const count = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductCount').innerHTML;
    const container = document.getElementsByClassName('thb-filter-count');

    for (var item of container) {
      item.innerHTML = count;
      item.classList.remove('loading');
    }
    //Re-enable the mobile and desktop stock checkboxes now the other filters have finished loading
    document.querySelectorAll('.decorative-stock-filter').forEach((stockToggle) => stockToggle.disabled = false);
  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');

    const facetDetailsElements =
      parsedHTML.querySelectorAll('#FacetFiltersForm .js-filter, #FacetFiltersFormDrawer .js-filter');
    const matchesIndex = (element) => {
      const jsFilter = event ? event.target.closest('.js-filter') : undefined;
      return jsFilter ? element.dataset.index === jsFilter.dataset.index : false;
    };
    const facetsToRender = Array.from(facetDetailsElements).filter(element => !matchesIndex(element));
    const countsToRender = Array.from(facetDetailsElements).find(matchesIndex);

    facetsToRender.forEach((element) => {
      document.querySelector(`.js-filter[data-index="${element.dataset.index}"]`).innerHTML = element.innerHTML;
    });

    FacetFiltersForm.renderActiveFacets(parsedHTML);
    FacetFiltersForm.renderAdditionalElements(parsedHTML);

    if (countsToRender) FacetFiltersForm.renderCounts(countsToRender, event.target.closest('.js-filter'));
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = ['.active-facets'];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (!activeFacetsElement) return;
      document.querySelector(selector).innerHTML = activeFacetsElement.innerHTML;
    });

    FacetFiltersForm.toggleActiveFacets(false);
  }

  static renderAdditionalElements(html) {
    const mobileElementSelectors = ['.mobile-filter-count'];

    mobileElementSelectors.forEach((selector) => {
      if (!html.querySelector(selector)) return;
      document.querySelector(selector).innerHTML = html.querySelector(selector).innerHTML;
    });

  }

  static renderCounts(source, target) {
    const targetElement = target.querySelector('.facets__selected');
    const sourceElement = source.querySelector('.facets__selected');

    if (sourceElement && targetElement) {
      target.querySelector('.facets__selected').outerHTML = source.querySelector('.facets__selected').outerHTML;
    }
  }

  static updateURLHash(searchParams) {
    history.pushState({
      searchParams
    }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  }

  static getSections() {
    return [
      {
        section: document.getElementById('product-grid').dataset.id,
      }];
  }

  onSubmitHandler(event) {
    event.preventDefault();

    //Because there are two <facet-filters-form>, we need the FormData from both - Previously just the form data from the one that generated the event was used which would wipe out the other's applied filters/sort options
    const formData = new FormData();
    document.querySelectorAll('facet-filters-form form').forEach((form) => {
      const singleFormData = new FormData(form);
      for (let [key, value] of singleFormData.entries()) {
        formData.append(key, value);
      }
    });

    const searchParams = new URLSearchParams(formData);

    if (searchParams.get('filter.v.price.gte') === "0.00") {
      searchParams.delete('filter.v.price.gte');
    }
    if (document.querySelector('.price_slider')) {
      if (searchParams.get('filter.v.price.lte') === parseFloat(document.querySelector('.price_slider').dataset.max).toFixed(2)) {
        searchParams.delete('filter.v.price.lte');
      }
    }
    let searchParamsStr = searchParams.toString();
    // If the availiability or 'in stock' metafield filter is removed, also remove the other as they should always be used in tandem
    if (!searchParamsStr.includes("filter.v.availability=1") && searchParamsStr.includes("filter.p.m.custom.in_stock=1")) {
      searchParamsStr = searchParamsStr.replace("&filter.p.m.custom.in_stock=1", "").replace("filter.p.m.custom.in_stock=1&", "").replace("?filter.p.m.custom.in_stock=1", "")
    } else if (searchParamsStr.includes("filter.v.availability=1") && !searchParamsStr.includes("filter.p.m.custom.in_stock=1")) {
      searchParamsStr = searchParamsStr.replace("filter.v.availability=1", "").replace("filter.v.availability=1&", "").replace("?filter.v.availability=1", "")
    }
    FacetFiltersForm.renderPage(searchParamsStr, event);
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    const url = event.currentTarget.href.indexOf('?') == -1 ? '' : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
    FacetFiltersForm.renderPage(url);
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();


class FacetRemove extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll('a').forEach((item) => {
      item.addEventListener('click', (event) => {
        event.preventDefault();
        const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
        form.onActiveFilterClick(event);
      });
    });

    const observer = new MutationObserver((mutationsList, observer) => {
      for (const mutation of mutationsList) {
        if (mutation.type === 'childList') this.activeFilterCount();
      }
    });

    observer.observe(this, { childList: true, subtree: true });

    this.activeFilterCount();
  }

  activeFilterCount() {
    const filterCount = document.querySelector('.facets-toggle [data-filter-count]');

    if (this.querySelectorAll('.active-facets__button').length > 0) {
      this.removeAttribute('hidden');
      if (filterCount) filterCount.innerText = `(${this.querySelectorAll('.active-facets__button').length})`;
    } else {
      this.setAttribute('hidden', true);
      if (filterCount) filterCount.innerText = '';
    }
  }
}

customElements.define('facet-remove', FacetRemove);

/**
 *  @class
 *  @function PriceSlider
 */
class PriceSlider extends HTMLElement {

  constructor() {
    super();
  }
  connectedCallback() {
    let slider = this.querySelector('.price_slider'),
      amounts = this.querySelector('.price_slider_amount'),
      args = {
        start: [parseFloat(slider.dataset.minValue || 0), parseFloat(slider.dataset.maxValue || slider.dataset.max)],
        connect: true,
        step: 10,
        direction: document.dir,
        range: {
          'min': 0,
          'max': parseFloat(slider.dataset.max)
        }
      },
      event = new CustomEvent('input'),
      form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');

    if (slider.classList.contains('noUi-target')) {
      slider.noUiSlider.destroy();
    }
    noUiSlider.create(slider, args);

    slider.noUiSlider.on('update', function (values) {
      amounts.querySelector('.field__input_min').value = values[0];
      amounts.querySelector('.field__input_max').value = values[1];
    });
    slider.noUiSlider.on('change', function (values) {
      form.querySelector('form').dispatchEvent(event);
    });
  }
}
customElements.define('price-slider', PriceSlider);

window.addEventListener('load', () => {
  new FacetsToggle();
});